import { render, staticRenderFns } from "./Subtitle.vue?vue&type=template&id=157d8949&scoped=true&"
import script from "./Subtitle.vue?vue&type=script&lang=js&"
export * from "./Subtitle.vue?vue&type=script&lang=js&"
import style0 from "./Subtitle.vue?vue&type=style&index=0&id=157d8949&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157d8949",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsSeguroCombinadaTooltip: require('/var/web/bet777.es/components/elements/seguro-combinada-tooltip.vue').default})
